import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { Row } from 'reactstrap';

import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import SkeletonHitCard from 'Components/Cards/SkeletonHitCard';
import useFetchRecentlyViewed from 'Hooks/useFetchRecentlyViewed';
import HitCard from 'Components/Cards/HitCard';

const messages = defineMessages({
  title: {
    id: 'recentlyviewedpage.title',
    defaultMessage: 'Recently Viewed | PC and Steam Games | Fanatical',
  },
});

/**
 * dedicated page to display the last 36 viewed products across the site
 * @param {Object} intl contains format message for translations
 */
const RecentlyViewedPage = ({ intl }) => {
  const { formatMessage } = intl;
  const { recentlyViewedHits } = useFetchRecentlyViewed(36);

  return (
    <div className="container">
      <Meta title={formatMessage(messages.title)} url="recently-viewed" />
      <NoIndex />
      <div className="pb-5 pt-5">
        <h1 className="pb-3">
          <FormattedMessage id="recentlyviewedpage.header" defaultMessage="Recently Viewed" />
        </h1>

        <Row className="recommendation-container">
          {recentlyViewedHits?.length === 0 &&
            <SkeletonHitCard
              numberOfCards={36}
              lgSize={4}
              mdSize={4}
              smSize={6}
              xsSize={6}
            />
          }
          {recentlyViewedHits?.length > 0 && recentlyViewedHits.map(hit =>
            <HitCard
              key={hit.objectID}
              hit={hit}
              xsSize={6}
              smSize={6}
              mdSize={4}
              lgSize={4}
            />,
          )}
        </Row>
      </div>
    </div>
  );
};

export default RecentlyViewedPage;
